export default "__VITE_ASSET__DC5m7gnB__"